import { environment } from '@environments/environment';
import { API_VERSION } from '../api-version';
export const VERSION_API: any = 'api/v1.0/riesgos-admision/';
export const API_URL: any = environment.API_URL + VERSION_API;
export const API_V1_0: any = environment.API_URL + API_VERSION.v1;
export const API_V1_1: any = environment.API_URL + API_VERSION.v2;